import { InjectionToken } from '@angular/core';
import { Account } from '@df/account/account.interfaces';

export namespace NDfAccount {
    export const DEFAULT_CONFIG = <IModuleOptions>{
        navigation: [],
        historyLoadQty: 3,
        historyProductVerbosity: 1
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_ACCOUNT_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_CONFIG
    });

    export interface IModuleOptions {
        navigation: Account.INavigationItem[];
        historyLoadQty: number;
        historyProductVerbosity?: 1 | 2 | 3;
    }
}
